import React, { useState } from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';

import { Heading5 } from '../../../components/Typography';

import './index.scss';

const FERTILITY_CONSULTATION_IFRAME_SRC =
  process.env.REACT_APP_FERTILITY_CONSULTATION_IFRAME;
const STD_CONSULTATION_IFRAME_SRC =
  process.env.REACT_APP_STD_CONSULTATION_IFRAME;

const OneDocIframe = ({ type, language }) => {
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(false);

  const handleLoading = () => setLoading(false);

  const handleError = () => {
    setLoading(false);
    setError(true);
  };

  let src = '';

  if (type === 'fertilityConsultation') {
    src = FERTILITY_CONSULTATION_IFRAME_SRC;
  } else if (type === 'stdConsultation') {
    src = STD_CONSULTATION_IFRAME_SRC;
  }

  src = src.replace('/de/', `/${language}/`);

  return (
    <div className='one-doc-iframe'>
      {loading && (
        <div className='one-doc-iframe__loading-overlay'>
          <div className='one-doc-iframe__loader' />
        </div>
      )}
      {error ? (
        <Heading5 className='one-doc-iframe__error-message'>
          <FormattedMessage
            id='test-result.try-again-later'
            defaultMessage='Something went wrong. Please try again later.'
          />
        </Heading5>
      ) : (
        <iframe
          src={src}
          title='OneDoc Iframe'
          width='100%'
          height='100%'
          frameBorder={0}
          onLoad={handleLoading}
          onError={handleError}
          className='one-doc-iframe__iframe'
        />
      )}
    </div>
  );
};

OneDocIframe.propTypes = {
  type: PropTypes.string,
  language: PropTypes.string,
};

export default OneDocIframe;
